<template>
  <div class="featured-search">
    <!-- Zip Input Field -->
    <advisor-carousel
      :zipcode="zipcode"
      :longitude="longitude"
      :latitude="latitude"
      :advisortypecategory="advisortypecategory"
      :labeltext="labeltext"
      :blockid="blockid"
      :hidezip="hidezip"
      :locationcode="locationcode"
      :headingtag="headingtag"
      :advisorheadingtag="advisorheadingtag"
      >
    </advisor-carousel>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import AdvisorCarousel from "./components/advisorCarousel.vue";

export default {
    data() {
    return {
      zipcode: this.locZip,
      latitude: this.locLat,
      longitude: this.locLong,
      advisortypecategory : this.locType,
      labeltext: this.locLabel,
      blockid: this.locBlockid,
      hidezip: this.locHidezip,
      locationcode: this.locLocationcode,
      headingtag: this.locHeadingtag,
      advisorheadingtag: this.locAdvisorheadingtag
    }
  },
    mounted() {
      // need to check for data here so we can remove the timeout
  },
  components: {
    "advisor-carousel": AdvisorCarousel
  },
    methods: {
      ...mapActions([
      ]),
      renderCards() {

      },
    },
  props: {
    locLong: String,
    locLat: String,
    locZip: String,
    locType: String,
    locLabel: String,
    locBlockid : String,
    locHidezip : String,
    locLocationcode : String,
    locHeadingtag: String,
    locAdvisorheadingtag: String
  }
};
</script>
